import React, { useEffect } from "react";
import { setupPresence } from "../Components/firebase"; // same helper you already have

const CurrentUserContext = React.createContext({
  currentUser: null,
  setCurrentUser: () => {},
});

const CurrentUserProvider = ({ currentUser, setCurrentUser, children }) => {
  useEffect(() => {
    if (!currentUser?.id) return;

    // initial presence
    setupPresence(currentUser.id);
    // re-register on tab visibility or network reconnect
    const handleVisibility = () => {
      if (!document.hidden) setupPresence(currentUser.id);
    };
    const handleOnline = () => setupPresence(currentUser.id);

    document.addEventListener("visibilitychange", handleVisibility);
    window.addEventListener("online", handleOnline);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibility);
      window.removeEventListener("online", handleOnline);
    };
  }, [currentUser?.id]);

  return (
    <CurrentUserContext.Provider value={{ currentUser, setCurrentUser }}>
      {children}
    </CurrentUserContext.Provider>
  );
};

export { CurrentUserContext, CurrentUserProvider };
